import theme from "@chakra-ui/theme";
import styled from "@emotion/styled";
import { Link } from "gatsby";
import IQuote from "@images/quote.png";

export const StickyNavContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  // height: 154px;
`;

export const NavContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
`;

export const SubNav = styled.nav`
  padding: 1rem 2rem;
  box-sizing: border-box;
  display: flex;
  background-color: #fff;
  /* TODO sort out mobile */
  @media (max-width: ${theme.breakpoints.xl};) {
    display: none;
  }
`;

export const NavContent = styled.div`
  width: 100%;
  max-width: ${theme.breakpoints.xl};
  @media (max-width: ${theme.breakpoints.lg}) {
    align-items: center;
    justify-content: space-between;
  }
`;

export const LeftItems = styled.ul`
  margin: 0;
  margin-left: 2rem;
  display: flex;
  align-items: center;
  list-style-type: none;
  list-style-image: none;
`;

export const RightItems = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const HomeLogoNavLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    max-width: 392px;
    max-height: 84px;
    width: 100%;
    height: auto;
  }
`;

export const HomeLogoSquareHero = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    width: 70px;
    height: 70px;
  }
`;

export const HomeLogoHero = styled(Link)`
  svg {
    max-width: 392px;
    max-height: 84px;
    width: 100%;
    height: auto;
  }
`;
export const HomeLogo = styled.span`
  width: 392px;
  height: 84px;
  background-image: url(@images/icons/p_check.inline.svg);
`;

export const DropdownTitle = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-right: 1.5rem;

  &:hover {
    & > svg {
      fill: var(--chakra-colors-primary);
    }
  }
`;

export const DropdownList = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-right: 1.5rem;

  &:hover {
    & > svg {
      fill: var(--chakra-colors-primary);
    }
  }
`;

export const CheveronLink = styled.span`
  a[aria-expanded="true"] .chakra-icon {
    transform: rotate(-180deg);
    transition: transform 0.2s ease 0s;
  }
`;

export const LeftCarouselContainer = styled.div`
  .carousel .slide {
    text-align: left;
    width: 100%;
  }
`;

export const HideSlickNext = styled.span`
  .slick-arrow.slick-prev,
  .slick-arrow.slick-next {
    display: none !important;
  }

  .slick-dots li button::before {
    font-size: 15px;
  }
`;

export const ActiveScrollSpy = styled.div`
  .active-scroll-spy {
    color: #3570ac;
    border-left: 3px solid #3570ac;
    display: block;
  }
`;

export const CarouselThumbnailHero = styled.div`
  .slider-wrapper {
    margin: auto;
  }
  .slick-slide {
    text-align: center;
    position: relative;
  }
  .slick-slide:focus {
    outline: none;
  }
  .slick-slide-title {
    text-transform: capitalize;
  }
  .slick-slide-image {
    width: auto;
    height: 100%;
    margin: 0 auto;
  }
  .slick-slide-label {
    color: #fff;
    padding: 10px;
    position: absolute;
    left: 0px;
    font-size: 1.5em;
    bottom: 0px;
    width: 100%;
  }
  .slick-prev:before,
  .slick-next:before {
    color: #777777;
  }

  .active-thumbnail {
    border: 2px solid #3672af;
  }
`;

export const ThumbnailSliderWrap = styled.div`
  .slick-thumbnail-slide {
    padding: 0.5rem;
  }

  .slick-slider {
    height: 120px;
    overflow: hidden;
  }
`;

export const ZoomSliderImage = styled.div`
  .slick-slide-image {
    max-width: 100%;
    margin: auto;
  }
`;

export const PageWrapperHero = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--chakra-fonts-heading);
  }

  h1 {
    font-size: var(--chakra-fontSizes-h1s);
    font-weight: var(--chakra-fontWeights-bold);
    line-height: var(--chakra-space-10);    
  }

  h2 {
    font-size: var(--chakra-fontSizes-h2s);
    line-height: var(--chakra-space-9); 
    font-weight: 700;
  }

  h3 {
    font-size: var(--chakra-fontSizes-h3s);
    line-height: var(--chakra-space-9); 
    font-weight: 700;
  }

  h4 {
    font-size: var(--chakra-fontSizes-h4);
    font-weight: 700;
  }

  h5 {
    font-size: var(--chakra-fontSizes-h5);
    font-weight: 700;
  }

  h6 {
    font-size: var(--chakra-fontSizes-h6);
    font-weight: 700;
  }

  :focus, :focus-visible, *[data-focus]: {
    box-shadow: "none !important",
    outline: "none !important",
  }

  .js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }

  [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
    outline: none;
  }

  @media (min-width: ${theme.breakpoints.md}) {
    h1 {
      font-size: var(--chakra-fontSizes-h1m);
      line-height: var(--chakra-space-12); 
    }
  
    h2 {
      font-size: var(--chakra-fontSizes-h2m);
      line-height: var(--chakra-space-12); 
    }
  
    h3 {
      font-size: var(--chakra-fontSizes-h3m);
      line-height: var(--chakra-space-12); 
    }
  }

  @media (min-width: ${theme.breakpoints.xl}) {
    h1 {
      font-size: var(--chakra-fontSizes-h1);
      line-height: 3.75rem;
    }
  
    h2 {
      font-size: var(--chakra-fontSizes-h2);
      line-height: 3.5rem;
    }
  
    h3 {
      font-size: var(--chakra-fontSizes-h3);
      line-height: 3rem;
    }
  }
`;

export const BrandHeadingHero = styled.div`
  ol {
    padding-left: 1.5rem;
  }
  h1 {
    margin-bottom: var(--chakra-space-7);
  }
  h2 {
    margin-bottom: var(--chakra-space-7);
  }
  p {
    font-size: var(--chakra-fontSizes-h5);
  }
`;

export const MediaCoverHero = styled.div`
  overflow-x: hidden;
  h1 {
    margin-bottom: var(--chakra-space-4);
  }

  .custom-video-cover {
    border-radius: 5px;
    overflow-x: hidden;
    .custom-video-play-icon {
      transform: scale(1);
      transition: 0.3s ease-in-out;
      svg {
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.4));
      }
    }
    img {
      border-radius: 5px;
    }
  }

  .custom-video-cover:hover {
    .custom-video-play-icon {
      transform: scale(1.1);
      svg {
        fill: #3570ac;
      }
      svg * {
        fill-opacity: 1;
      }
    }
  }
`;

export const BannerHero = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--chakra-colors-blue700);
  }

  p {
    color: var(--chakra-colors-misc800);
  }

  overflow-x: hidden;

  h1 {
    margin-bottom: ${theme.space[4]};
    font-size: ${theme.fontSizes["3xl"]};

    @media (min-width: ${theme.breakpoints.md}) {
      font-size: ${theme.fontSizes["3xl"]};
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      font-size: ${theme.fontSizes["4xl"]};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      font-size: ${theme.fontSizes["5xl"]};
    }
  }

  p {
    color: inherit;
    line-height: ${theme.sizes[6]};

    @media (min-width: ${theme.breakpoints.md}) {
      font-size: 1.125rem;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      font-size: 1.125rem;
      line-height: ${theme.sizes[6]};
    }
  }
`;

export const BannerFluidImageHero = styled.div`
  img {
    height: 100%;
  }
`;

export const ThumbnailCardHero = styled.div`
  h3 {
    color: var(--chakra-colors-blue700);
    font-weight: 600;
  }

  h4 {
    font-size: var(--chakra-fontSizes-h4);
    margin-bottom: var(--chakra-space-5);
    margin-top: var(--chakra-space-2);
  }

  p {
    color: var(--chakra-colors-black);
  }

  button {
    margin-top: var(--chakra-space-2);
  }

  img {
    border-radius: 5px;
  }
`;

export const NeedHelpIconHero = styled.div`
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const BuildFlagLogo = styled.div`
  svg {
    max-width: 7.125rem;
    max-height: 4.75rem;
    width: 100%;
    height: auto;
  }
`;

export const HeaderFlagLogo = styled.div`
  svg {
    max-width: 2.8125rem;
    max-height: 1.75rem;
    width: 100%;
    height: auto;
  }
`;

export const IntroduceCardHero = styled.div`
  h3,
  h4,
  p {
    margin-bottom: var(--chakra-space-5);
  }
`;

export const CompanyHistoryHero = styled.div`
  margin-bottom: var(--chakra-space-20);
  p {
    margin-bottom: var(--chakra-space-10);
  }
  ol {
    margin-left: var(--chakra-space-5);
    margin-bottom: var(--chakra-space-10);
  }
  blockquote {
    margin-left: var(--chakra-space-5);
    margin-right: var(--chakra-space-5);
    margin-bottom: var(--chakra-space-10);
    p,
    h4 {
      margin-bottom: var(--chakra-space-5);
      padding-left: var(--chakra-space-14);
    }
    p::before {
      background-color: red;
      content: "";
      height: 5rem;
      display: inline-block;
    }
    display: block;
  }

  blockquote::before {
    content: "";
    width: 7rem;
    height: 5rem;
    display: inline-block;
    background-image: url(${IQuote});
    position: absolute;
    background-repeat: no-repeat;
  }

  @media (min-width: ${theme.breakpoints.md}) {
    blockquote {
      margin-left: var(--chakra-space-10);
      margin-right: var(--chakra-space-10);
    }
  }

  @media (min-width: ${theme.breakpoints.lg}) {
    blockquote {
      margin-left: var(--chakra-space-32);
      margin-right: var(--chakra-space-32);
    }
  }
`;

export const SlideStoryHero = styled.div`
  h1,
  h2,
  h3,
  h4 {
    color: var(--chakra-colors-black);
    font-weight: 600;
    margin-bottom: var(--chakra-space-5);
  }

  h4 {
    margin-top: var(--chakra-space-5);
    line-height: var(--chakra-space-4);
  }

  p {
    color: var(--chakra-colors-black);
    // margin-bottom: var(--chakra-space-7);
  }

  // button {
  //   margin-bottom: var(--chakra-space-2);
  // }
`;

export const CheckboxGroupHero = styled.div`
  span[data-invalid][data-focus] {
    border-color: var(--chakra-colors-red-500) !important;
  }
`;
